// QnASection is an accordion used for displaying frequently asked questions
import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import standardiseContentfulId from '../util/standardiseContentfulId';
var defaultProps = {
  heading: ''
};

/**
 * QnASection is an accordion which has an optional heading and question & answer blocks
 * @param {string} heading Optional heading for the QnA section
 * @param {array} qaBlocks The questions and answers to display from contentful
 */
var QnASection = function QnASection(_ref) {
  var heading = _ref.heading,
    qaBlocks = _ref.qaBlocks;
  var _useState = useState(null),
    currentlyOpen = _useState[0],
    setCurrentlyOpen = _useState[1];
  var onClickHandler = function onClickHandler(contentfulId) {
    if (currentlyOpen === contentfulId) {
      setCurrentlyOpen(null);
    } else {
      setCurrentlyOpen(contentfulId);
    }
  };
  var getChevron = function getChevron(contentfulId) {
    return currentlyOpen === contentfulId ? /*#__PURE__*/React.createElement(FaChevronUp, {
      "data-testid": "chevron-up",
      size: 16
    }) : /*#__PURE__*/React.createElement(FaChevronDown, {
      "data-testid": "chevron-down",
      size: 16
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "qna-section"
  }, heading && /*#__PURE__*/React.createElement("h2", {
    "data-testid": "qna-section-heading",
    className: "qna-section-heading"
  }, heading), /*#__PURE__*/React.createElement(Accordion, null, qaBlocks.map(function (qaBlock) {
    var contentfulId = qaBlock.contentfulId,
      question = qaBlock.question,
      answer = qaBlock.answer;
    return /*#__PURE__*/React.createElement(Card, {
      key: contentfulId,
      id: standardiseContentfulId(contentfulId)
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
      as: Card.Header,
      eventKey: contentfulId,
      onClick: function onClick() {
        return onClickHandler(contentfulId);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "qna-question"
    }, /*#__PURE__*/React.createElement("h4", null, question)), getChevron(contentfulId)), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: contentfulId
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
      className: "qna-answer"
    }, answer))));
  })));
};
QnASection.defaultProps = defaultProps;
export { QnASection };